import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { BasicTable } from 'components/DebFormComponents/Table/BasicTable';

import './ExpertDataPolicyTables.sass';

const consentLabel = (value) => {
  if (value === 'Ja') return 'Zugestimmt';
  return 'Abgelehnt';
};

const header = (title, key) => <TableCell key={key}>{title}</TableCell>;

export const ExpertDataPolicyTables = ({ installer, experts, onCompanyEdit, onExpertEdit }) => {
  const expertsWithEgcId = experts.filter((expert) => Boolean(expert.egcid));

  return (
    <div className="expert-data-policy-tables">
      <section>
        <h2>Firmenebene</h2>
        <BasicTable
          headers={[
            header('Firmenname', 'company'),
            header('E-Mail-Adresse', 'email'),
            header('Informationsversand', 'information'),
            header('Adressveröffentlichung', 'address'),
            header('', 'action'),
          ]}
          rows={
            <TableRow>
              <TableCell data-label="Firmenname">{installer.firmenname1 || '-'}</TableCell>
              <TableCell data-label="E-Mail-Adresse">{installer.email || '-'}</TableCell>
              <TableCell data-label="Informationsversand">
                {consentLabel(installer.zuInfoversand)}
              </TableCell>
              <TableCell data-label="Adressveröffentlichung">
                {consentLabel(installer.zuAdressveroeff)}
              </TableCell>
              <TableCell className="expert-data-policy-tables__action-cell" data-label="Aktion">
                <ActionButton title="Datenschutz bearbeiten" onClick={onCompanyEdit} />
              </TableCell>
            </TableRow>
          }
        />
      </section>
      <section>
        <h2>Fachkräfteebene</h2>
        <p className="expert-data-policy-tables__expert-note">
          Hier können nur die Datenschutzeinstellungen von Fachkräften mit Zusatzkonto geändert
          werden.
        </p>
        <BasicTable
          headers={[
            header('Name', 'name'),
            header('E-Mail-Adresse', 'email'),
            header('Informationsversand', 'information'),
            header('', 'action'),
          ]}
          rows={expertsWithEgcId.map((expert) => (
            <TableRow key={expert.id}>
              <TableCell data-label="Name">
                {[expert.vorname, expert.nachname].filter(Boolean).join(' ') || '-'}
              </TableCell>
              <TableCell data-label="E-Mail-Adresse">{expert.netzportalEmail || '-'}</TableCell>
              <TableCell data-label="Informationsversand">
                {consentLabel(expert.consentInfoversand)}
              </TableCell>
              <TableCell className="expert-data-policy-tables__action-cell" data-label="Aktion">
                <ActionButton title="Datenschutz bearbeiten" onClick={() => onExpertEdit(expert)} />
              </TableCell>
            </TableRow>
          ))}
        />
      </section>
    </div>
  );
};

ExpertDataPolicyTables.propTypes = {
  installer: PropTypes.shape({
    firmenname1: PropTypes.string,
    email: PropTypes.string,
    zuInfoversand: PropTypes.string,
    zuAdressveroeff: PropTypes.string,
  }).isRequired,
  experts: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCompanyEdit: PropTypes.func.isRequired,
  onExpertEdit: PropTypes.func.isRequired,
};
